import React, { ChangeEvent, FC, useState } from 'react';
import { Grid, makeStyles, Tabs } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { LargeTab, TextTransform } from 'components';
import { ContentEmailSpecListInput } from 'api';

enum TabValues {
  Enabled,
  Disabled,
  Sent,
}

interface Props {
  filter: ContentEmailSpecListInput;
  setFilter: (filter: ContentEmailSpecListInput) => void;
  setIsSent: (value: boolean) => void;
}

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
}));

const TableHeader: FC<Props> = ({ filter, setFilter, setIsSent }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [tab, setTab] = useState<TabValues>(TabValues.Enabled);

  function onChangeTabs(event: ChangeEvent<HTMLDivElement>, value: TabValues) {
    setTab(value);

    if (value === TabValues.Sent) {
      setIsSent(true);
      return;
    }

    setIsSent(false);
    setFilter({
      ...filter,
      recurringOnly: value === TabValues.Enabled,
    });
  }

  return (
    <Grid className={classes.root} container alignItems="center" justify="space-between">
      <Grid item>
        <Tabs value={tab} onChange={onChangeTabs}>
          <LargeTab
            label={<TextTransform transform="capitalize">{t('common:recurring')}</TextTransform>}
            value={TabValues.Enabled}
          />
          <LargeTab
            label={<TextTransform transform="capitalize">{t('common:nonRecurring')}</TextTransform>}
            value={TabValues.Disabled}
          />
          <LargeTab label={t('common:sent')} value={TabValues.Sent} />
        </Tabs>
      </Grid>
    </Grid>
  );
};

export default TableHeader;
